"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactUse = require("react-use");

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _SenderGiftLanguage = _interopRequireDefault(require("../../containers/SenderGiftLanguage/SenderGiftLanguage"));

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    divider: {
      margin: spacing(2, 0)
    },
    gradIcon: {
      color: palette.green.main,
      marginRight: spacing(2)
    },
    breakWord: {
      wordBreak: 'break-word'
    }
  };
});

var GiftInviteUrl = function GiftInviteUrl(_ref2) {
  var link = _ref2.link;
  var classes = useStyles();
  var copyToClipBoard = (0, _reactUse.useCopyToClipboard)()[1];
  return /*#__PURE__*/_react.default.createElement(_material.Grid, null, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "row",
    wrap: "nowrap",
    justifyContent: "space-between",
    alignItems: "flex-end"
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 8
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Label-Table-Left-Static Text-Uppercase"
  }, /*#__PURE__*/_react.default.createElement(_SenderGiftLanguage.default, null), " invite url"), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: (0, _classnames.default)('Body-Small-Static', classes.breakWord)
  }, link)), /*#__PURE__*/_react.default.createElement(_material.Button, {
    onClick: function onClick() {
      return copyToClipBoard(link);
    }
  }, "Copy URL")), /*#__PURE__*/_react.default.createElement(_material.Divider, {
    className: classes.divider
  }), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "row",
    wrap: "nowrap",
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_ui.DashboardIcon, {
    icon: "graduation-cap",
    className: classes.gradIcon
  }), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: (0, _classnames.default)('Body-Small-Inactive', classes.breakWord)
  }, "You can open the ", /*#__PURE__*/_react.default.createElement(_SenderGiftLanguage.default, null), " link, while logged in Alyce. The ", /*#__PURE__*/_react.default.createElement(_SenderGiftLanguage.default, null), " status will not be changed in ", /*#__PURE__*/_react.default.createElement(_SenderGiftLanguage.default, null), " preview mode!")));
};

GiftInviteUrl.propTypes = {
  link: _propTypes.default.string.isRequired
};
var _default = GiftInviteUrl;
exports.default = _default;